import { render } from "./ZhaiCard.vue?vue&type=template&id=bd6eabe4&scoped=true"
import script from "./ZhaiCard.vue?vue&type=script&lang=js"
export * from "./ZhaiCard.vue?vue&type=script&lang=js"

import "./ZhaiCard.vue?vue&type=style&index=0&id=bd6eabe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6eabe4"]])

export default __exports__